import { ReactNode } from "react";

interface ScreenshotSectionProps {
  title: string;
  description: string;
  imageSrc?: string;
  imageAlt?: string;
  imagePosition?: "left" | "right";
  children?: ReactNode;
}

export function ScreenshotSection({
  title,
  description,
  imageSrc,
  imageAlt = "Feature screenshot",
  imagePosition = "right",
  children
}: ScreenshotSectionProps) {
  return (
    <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${imagePosition === "left" ? "lg:flex-row-reverse" : ""}`}>
      <div className={imagePosition === "left" ? "lg:order-2" : ""}>
        <h3 className="text-2xl font-bold mb-4">{title}</h3>
        <p className="text-lg text-muted-foreground leading-relaxed mb-6">
          {description}
        </p>
        {children}
      </div>

      <div className={imagePosition === "left" ? "lg:order-1" : ""}>
        {imageSrc ? (
          <div className="relative rounded-lg overflow-hidden shadow-2xl border border-border">
            <img
              src={imageSrc}
              alt={imageAlt}
              className="w-full h-auto"
            />
          </div>
        ) : (
          <div className="relative rounded-lg overflow-hidden shadow-2xl border border-border bg-gradient-to-br from-muted/50 to-muted aspect-video flex items-center justify-center">
            <p className="text-muted-foreground text-sm">Feature Preview</p>
          </div>
        )}
      </div>
    </div>
  );
}
